import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ContainerProvider } from './state/ContainerContext';
import { CriteriaProvider } from './state/CriteriaContext';
import { SessionProvider } from './state/SessionContext';
import { ThemeProvider } from './state/ThemeContext';
import type { Container } from './data/container';
import { AppShell } from './ui/AppShell';
import { BookingScreen } from './ui/screens/BookingScreen';
import { ConfirmationScreen } from './ui/screens/ConfirmationScreen';
import { DoorScreen } from './ui/screens/DoorScreen';
import { HomeScreen } from './ui/screens/HomeScreen';
import { LoginScreen } from './ui/screens/LoginScreen';
import { ProfileScreen } from './ui/screens/ProfileScreen';
import { ReservationDetailScreen } from './ui/screens/ReservationDetailScreen';
import { ReservationsScreen } from './ui/screens/ReservationsScreen';
import { RestaurantDetailScreen } from './ui/screens/RestaurantDetailScreen';
import { SearchScreen } from './ui/screens/SearchScreen';

/**
 * Rutas de la aplicación.
 *
 * Por la URL solo viajan identificadores, nunca objetos serializados: cada pantalla vuelve a
 * pedir sus datos al repositorio, que es lo que hace que un enlace compartido y una recarga
 * funcionen igual que una navegación normal.
 */
export function App({ container }: { container?: Container }) {
  return (
    <ContainerProvider container={container}>
      <ThemeProvider>
        <SessionProvider>
          <CriteriaProvider>
            <BrowserRouter>
              <AppShell>
                <Routes>
                  {/* Arranca en Inicio, nunca en el login: el descubrimiento es público. */}
                  <Route path="/" element={<HomeScreen />} />
                  <Route path="/buscar" element={<SearchScreen />} />
                  <Route path="/restaurante/:id" element={<RestaurantDetailScreen />} />
                  <Route path="/reservar/:id" element={<BookingScreen />} />
                  <Route path="/confirmacion/:id" element={<ConfirmationScreen />} />
                  <Route path="/reservas" element={<ReservationsScreen />} />
                  <Route path="/reservas/:id" element={<ReservationDetailScreen />} />
                  <Route path="/perfil" element={<ProfileScreen />} />
                  <Route path="/entrar" element={<LoginScreen />} />
                  {/* Pantalla del personal del restaurante, no de comensales. */}
                  <Route path="/puerta" element={<DoorScreen />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </AppShell>
            </BrowserRouter>
          </CriteriaProvider>
        </SessionProvider>
      </ThemeProvider>
    </ContainerProvider>
  );
}
